export let hollywoodMovies = [
    {
        "id": 188,
        "contents": 11,
        "name": "Recently Added",
        "videos": [
            {
                "duration": "Watch Now",
                "id": 227,
                "name": "Africa In Her Blood",
                "preview": "https://cdn.mobiotv.com/uk/Africa+In+Her+Blood.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/uk/Africa+in+Her+Blood.mp4",
                "subCategory":[]
            },
            {
                "duration": "Watch Now",
                "id": 228,
                "name": "Bloodstained Romance",
                "preview": "https://cdn.mobiotv.com/uk/Bloodstained+Romance.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/uk/Bloodstained+Romance.mp4",
                "subCategory":[]
            },{
                "duration": "Watch Now",
                "id": 229,
                "name": "In The Cage",
                "preview": "https://cdn.mobiotv.com/uk/In+The+Cage.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/uk/In+the+Cage.mp4",
                "subCategory":[]
            },{
                "duration": "Watch Now",
                "id": 230,
                "name": "Changing Hands",
                "preview": "https://cdn.mobiotv.com/uk/Changing+Hands.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            }
            ,{
                "duration": "Watch Now",
                "id":231,
                "name": "Death To You All",
                "preview": "https://cdn.mobiotv.com/uk/Death+To+You+All.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },
            {
                "duration": "Watch Now",
                "id":232,
                "name": "Fighting Nirvana",
                "preview": "https://cdn.mobiotv.com/uk/Fighting+Nirvana.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 233,
                "name": "Final Shift",
                "preview": "https://cdn.mobiotv.com/uk/Final+Shift.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 234,
                "name": "Governor's Daughters",
                "preview": "https://cdn.mobiotv.com/uk/Governor's+Daughters.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 235,
                "name": "Haiti Cherie: Wind Of Hope",
                "preview": "https://cdn.mobiotv.com/uk/Haiti+Cherie+Wind+Of+Hope.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 236,
                "name": "A Family On Edge",
                "preview": "https://cdn.mobiotv.com/uk/A+Family+On+Edge.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]
            }
        ]
    },
    {
        "id": 189,
        "contents": 11,
        "name": "Trending",
        "videos": [
            {
                "duration": "Watch Now",
                "id": 237,
                "name": "Is This A Joke?",
                "preview": "https://cdn.mobiotv.com/uk/Is+this+a+Joke.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },
            {
                "duration": "Watch Now",
                "id": 238,
                "name": "Jezebeth",
                "preview": "https://cdn.mobiotv.com/uk/Jezebeth.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 239,
                "name": "Layover",
                "preview": "https://cdn.mobiotv.com/uk/Layover.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 240,
                "name": "McCartney's Genes",
                "preview": "https://cdn.mobiotv.com/uk/McCartney's+Genes.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            }
            ,{
                "duration": "Watch Now",
                "id":241,
                "name": "Paramnesia",
                "preview": "https://cdn.mobiotv.com/uk/Paramnesia.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },
            {
                "duration": "Watch Now",
                "id":245,
                "name": "Pluto",
                "preview": "https://cdn.mobiotv.com/uk/Pluto.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 246,
                "name": "Preying For Mercy",
                "preview": "https://cdn.mobiotv.com/uk/Preying+For+Mercy.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 247,
                "name": "Super Tuesday",
                "preview": "https://cdn.mobiotv.com/uk/Super+Tuesday.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 248,
                "name": "The Alley",
                "preview": "https://cdn.mobiotv.com/uk/The+Alley.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 249,
                "name": "The Art of Pain",
                "preview": "https://cdn.mobiotv.com/uk/The+Art+of+Pain.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            }
        ]
    },{
        "id": 190,
        "contents": 11,
        "name": "Recommended",
        "videos": [
            {
                "duration": "Watch Now",
                "id": 250,
                "name": "The Cause",
                "preview": "https://cdn.mobiotv.com/uk/The+Cause.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },
            {
                "duration": "Watch Now",
                "id": 251,
                "name": "The Day The World Stopped",
                "preview": "https://cdn.mobiotv.com/uk/The+Day+The+World+Stopped.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 252,
                "name": "The Devil Made Me Do It",
                "preview": "https://cdn.mobiotv.com/uk/The+Devil+Made+Me+Do+It.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 253,
                "name": "The Gods",
                "preview": "https://cdn.mobiotv.com/uk/The+Gods.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            }
            ,{
                "duration": "Watch Now",
                "id":254,
                "name": "The Lenght of Spring",
                "preview": "https://cdn.mobiotv.com/uk/The+Length+Of+Spring.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },
            {
                "duration": "Watch Now",
                "id":255,
                "name": "The Phone in The Attic",
                "preview": "https://cdn.mobiotv.com/uk/The+Phone+in+The+Attic.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 256,
                "name": "The Pigman Murders",
                "preview": "https://cdn.mobiotv.com/uk/The+Pigman+Murders.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 257,
                "name": "Waiting To Die",
                "preview": "https://cdn.mobiotv.com/uk/Waiting+To+Die.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            },{
                "duration": "Watch Now",
                "id": 258,
                "name": "What If",
                "preview": "https://cdn.mobiotv.com/uk/What+If.jpg",
                "desc": "",
                "videoUrl": "",
                "subCategory":[]

            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/constants/hollywoodmovies.js